import styled from '@emotion/styled';

export const LegalPersonViewPageContainer = styled.div`
  width: 100%;
  height: 100%;
`;
